import { render, staticRenderFns } from "./CreateNewQuote.vue?vue&type=template&id=5025a1e0&scoped=true&"
import script from "./CreateNewQuote.vue?vue&type=script&lang=js&"
export * from "./CreateNewQuote.vue?vue&type=script&lang=js&"
import style0 from "./CreateNewQuote.vue?vue&type=style&index=0&id=5025a1e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5025a1e0",
  null
  
)

export default component.exports